import React from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { connect } from "react-redux";
import VersionWatcher from "./components/VersionWatcher";
// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/";
import AppRoute from "./routes/route";

// layouts
import VerticalLayout from "./components/Mainframe";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import {
  useAppSocket,
  useLostOrders,
  useBattleFieldOrders,
  usePriorityOrders,
  useTransferOrders,
} from "./app-socket/hooks";

function App() {
  useAppSocket();
  useLostOrders();
  useBattleFieldOrders();
  usePriorityOrders();
  useTransferOrders();

  return (
    <React.Fragment>
      <VersionWatcher />

      <Router>
        <Switch>
          {publicRoutes.map((route, idx) => (
            <AppRoute
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <AppRoute
              path={route.path}
              layout={VerticalLayout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              // profileData={getUserName()}
              exact
            />
          ))}
        </Switch>
      </Router>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

App.propTypes = {
  layout: PropTypes.object,
};

export default connect(mapStateToProps, null)(App);
